module.exports = __webpack_public_path__ + "static/media/bnb.4fcda529.png";